<template>
  <div>

    <!-- 充值 -->
    <baseBreadcrumb :page="$t('message.topUp')" :menu="$t('message.moneyManagement')"></baseBreadcrumb>
    <div class="body">
      <div class="bank">
        <div class="item" v-for="(item, index) in methodList" :key="index" :class="{ select: index == i }"
          @click="selectItem(item, index)">
          {{ item.value }}
          <i class="el-icon-check" v-show="index == i"></i>
        </div>
      </div>
      <!-- 表单 -->
      <div class="form">
        <el-form :model="datas" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="着金予定日:" prop="pay_reach_date">
            <el-date-picker v-model="datas.pay_reach_date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入金名義:(カタカナ記載)" prop="pay_name">
            <div class="mingyi">
              <el-popover placement="bottom" width="330" trigger="click">
                <el-input v-model="datas.pay_name" slot="reference"></el-input>
                <div class="list">
                  <div class="item" v-for="(item, index) in rujinList" @click="datas.pay_name = item.pay_account"
                    style="margin-bottom: 10px;">{{
                      item.pay_account }}</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="入金額:" prop="pay_amount">
            <el-input v-model="datas.pay_amount" type="number">
              <template slot="append">円</template> </el-input>
            <p class="hint">入金報告で、実際に入金する金額をご記入下さい。
              実際入金額と差異がありますと、入金反映が遅くなる原因になります。</p>
          </el-form-item>
          <el-form-item label="入金備考欄:" prop="name">
            <el-input v-model="datas.pay_remark"></el-input>
            <p class="hint">※入金報告の備考欄で質問を入れないでください。
              担当が異なりますので伝わりません。</p>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" style="width:100%" @click="bankPayBalance">提出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      methodList: [],
      accountList: [],
      i: 0,
      datas: {
        user_id: this.$route.query.userID,
        pay_bank_method: '',
        pay_amount: '',
        pay_name: '',
        pay_date: '',
        pay_reach_date: '',
        pay_remark: '',
      },
      rules: {
        pay_reach_date: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          }
        ],
        pay_name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          }
        ],
        pay_amount: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          }
        ],
      }
    };
  },
  computed: {
    rujinList() {
      let list = []
      this.accountList.forEach(item => {
        if (item.bill_method == this.datas.pay_bank_method) {
          list = item.list
        }
      })
      list.forEach(item => {
        if (item.is_default == 1) {
          this.datas.pay_name = item.pay_account
        } else {
          this.datas.pay_name = ''
        }
      })
      if (list == false) {
        this.datas.pay_name = ''
      }
      return list
    }
  },
  created() {
    this.payMethodList()
    this.clientPayAccountList()
  },
  methods: {
    clientPayAccountList() {
      this.$api.financialApi.clientPayAccountList(this.datas).then(res => {
        this.accountList = res.data.data[0].user_pay_account
      })
    },
    selectItem(item, index) {
      this.i = index
      this.datas.pay_bank_method = item.key
    },
    payMethodList() {
      this.$api.clienteleApi.payMethodList().then(res => {
        this.methodList = res.data
        this.selectItem(this.methodList[0], 0)
      })
    },
    // 充值
    bankPayBalance() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.clienteleApi.bankPayBalance(this.datas).then(res => {
            this.$message.success(res.msg)
            this.datas = {
              user_id: this.$route.query.userID,
              pay_bank_method: '',
              pay_amount: '',
              pay_name: '',
              pay_date: '',
              pay_reach_date: '',
              pay_remark: '',
            }
          })
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.bank {
  display: flex;

  .item {
    width: 226px;
    border: 1px solid #dfdfdf;
    text-align: center;
    line-height: 86px;
    height: 86px;
    margin-right: 48px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    position: relative;

    .el-icon-check {
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 40px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #B4272D;
      color: #fff;
      border-radius: 5px 0 5px 0;
      font-size: 25px;
      font-weight: bold;
    }
  }

  .select {
    color: #B4272D;
    border: 2px solid #B4272D;

  }

}

.form {
  width: 500px;
  margin-top: 48px;

  .hint {
    line-height: 20px;
    color: #B4272D;
    font-size: 12px;
    margin-top: 12px;
  }

  /deep/.el-date-editor {
    width: 100%;
  }
}

.list {
  .item {
    line-height: 40px;
    cursor: pointer;

    &:hover {
      // background-color: #B4272D;
      color: #B4272D;
    }
  }
}
</style>